var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerifiedBuyerIcon = function SvgVerifiedBuyerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m3.688-11.447a.75.75 0 0 0-1.047.166L6.909 9.85 5.281 8.222a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 .588.218.74.74 0 0 0 .547-.306L11.853 5.6a.75.75 0 0 0-.165-1.047"
  })));
};
export default SvgVerifiedBuyerIcon;